import React, { Component } from "react";
import ReactRoundedImage from "react-rounded-image";
import logo from "../../assets/img/brand/wizmen.png";
import ChakwalLogo from "../../assets/img/KJTextLogo.png";
import AaCottonLogo from "../../assets/img/aaCottonLogo.jpg";
import FBRlogo from "../../assets/img/FBR_Logo.jpeg";
import { Col, Row, Container, FormGroup, Input, Label } from "reactstrap";
import { baseurl } from "../../baseurl.js";
import { headers, companyId, username, token } from "../../utils/variables";
import { Redirect } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Responseloader from "./ShortCutComponents/ResponseLoader";
import "./chakwalPrintCss.css";
import QRCode from "react-qr-code";

var thisContex;
var UserName = localStorage.getItem("firstName");
var companylog = localStorage.getItem("profile_pic");
var companyNameLocal = localStorage.getItem("companyName");
var saleTaxGroup = localStorage.getItem("saleTaxGroup");
let companySym;
class PrintView extends Component {
  constructor(props) {
    super(props);

    let tempLogedIn = false;
    if (token != null) {
      tempLogedIn = true;
    }
    let propInvoiceId = this.props?.location?.state?.id || this.props?.id;
    // let propInvoiceId = 11;
    propInvoiceId = propInvoiceId ? propInvoiceId : -1;
    console.log("this.prop", this.props);
    console.log("this.prop", this.props?.location?.state?.headerPrefix);
    this.state = {
      logInStatus: tempLogedIn,
      invoiceNo: "",
      issueDate: "",
      dueDate: "",
      companyName: this.props?.location?.state?.companyName || companyNameLocal,
      companyAddress: this.props?.location?.state?.companyAddress || " ",
      invoiceTypeId: this.props?.location?.state?.invoiceTypeId || null,
      invoiceTypeDesc: this.props?.location?.state?.invoiceTypeDesc || null,
      clientName: "",
      compNtn: "",
      compStrn: "",
      clntCnic: "",
      clntNtax: "",
      clntStrn: "",
      fbr_inv_id: "",
      state: "",
      loadingResponce: false,
      setNextPrintPageFooter: false,
      setFooterData: [],
      headerPrefix:
        this.props?.location?.state?.headerPrefix === "NOT GRN OR PO"
          ? "Invoice"
          : this.props?.location?.state?.headerPrefix,
      total_btAmount: -1,
      invoiceId: propInvoiceId,
    };
    thisContex = this;
    companySym = `${baseurl}/getImages/labelCard/?fileName=${companylog}`;
  }
  componentDidMount() {
    this.getFooterDataWithId(1, 10);

    this.getPrintCall();
  }
  downloadInvoice() {
    const element = document.getElementById("pdfContent");
  }

  convertToCurrency(param_number) {
    return param_number !== 0 && param_number !== null && param_number > 0
      ? Number(
          param_number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        )?.toFixed(2)
      : 0;
  }
  componentDidUpdate(prevProps) {}
  getFooterDataWithId = (id, dataLength) => {
    thisContex.setState({ loadingResponce: true });
    return axios
      .post(
        `${baseurl}/masterData/getDocFooterSetupId`,
        { id, companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let response = res.data.data[0];
        console.log("hhhhh", response);
        let label;
        if (response.page_size === "F") {
          label = "Full";
        } else {
          label = "Half";
        }
        const formValuesFooterData = [];

        if (response.desc1 !== null) {
          formValuesFooterData.push({
            desc: response.desc1,
            enteredBy: response.Ent_by_1,
          });
        }
        if (response.desc_2 !== null) {
          formValuesFooterData.push({
            desc: response.desc_2,
            enteredBy: response.Ent_by_2,
          });
        }
        if (response.desc_3 !== null) {
          formValuesFooterData.push({
            desc: response.desc_3,
            enteredBy: response.Ent_by_3,
          });
        }
        if (response.desc_4 !== null) {
          formValuesFooterData.push({
            desc: response.desc_4,
            enteredBy: response.Ent_by_4,
          });
        }
        if (response.desc_5 !== null) {
          formValuesFooterData.push({
            desc: response.desc_5,
            enteredBy: response.Ent_by_5,
          });
        }
        if (response.desc_6 !== null) {
          formValuesFooterData.push({
            desc: response.desc_6,
            enteredBy: response.Ent_by_6,
          });
        }
        console.log("hhhhh>", formValuesFooterData);
        if (formValuesFooterData.length > 3 && dataLength > 25) {
          thisContex.setState({ setNextPrintPageFooter: true });
        } else {
          thisContex.setState({ setNextPrintPageFooter: false });
        }
        thisContex.setState({ setFooterData: formValuesFooterData });
        return formValuesFooterData.length;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        thisContex.setState({ loadingResponce: false });
      });
  };
  getPrintCall() {
    let invLable;
    axios
      .post(`${baseurl}/auth/getCompany`, {
        username: username,
      })
      .then((response) => {
        var data = response.data.data;

        for (let index = 0; index < data.length; index++) {
          if (data[index]?.COMPANY_ID == companyId)
            invLable = data[index]?.LABEL;
        }
        console.log("invLable......", invLable, companylog);
        companySym = `${baseurl}/getImages/labelCard/?fileName=${invLable}`;
      })
      .catch((error) => {
        console.log(error);
      });
    const { state } = this.props?.location;

    if (this.state.invoiceId !== -1) {
      thisContex.setState({ loadingResponce: true }); //AHMAD

      //   if (state?.printType === "Purchase") {
      // let endPoint =
      //   state?.headerPrefix === "Purchase Order"
      //     ? "getPrintPurchaseOrderView"
      //     : state?.headerPrefix === "GOODS RECEIPT NOTE"
      //     ? "getGrnPrintView"
      //     : state?.headerPrefix === "Sale" ||
      //       state?.headerPrefix === "Invoice Draft" ||
      //       state?.headerPrefix === "Sale Return"
      //     ? "getSalesPrint"
      //     : state?.headerPrefix === "Sale Order"
      //     ? "getSalesOrderPrint"
      //     : state?.headerPrefix === "Item Adjusment"
      //     ? "getItemAdjustmentPrint"
      //     : state?.headerPrefix === "Production Note"
      //     ? "getProductionNotePrint"
      //     : "getPrintPurchaseView";
      axios
        .post(
          //   `${baseurl}/masterData/${endPoint}`,
          `${baseurl}/masterData/getChakwalSalesPrint`,
          {
            username,
            invoiceId: state?.id,
            // invoiceId: 11,
            companyId,
          },
          headers
        )
        .then(function (response) {
          let res_mt = response.data.data[0];
          let res_det = response.data.data1;
          let totalBags = 0;
          let totalWeight = 0;
          let total_btAmount = 0;
          let totalsalesTaxPay = 0;
          let total_atAmount = 0;
          let invoiceNo = res_mt?.["DOCUMENT_NO"];
          let invBookId = res_mt?.["INV_BOOK_ID"];
          let compNtn = res_mt?.["comp_ntn"];
          let compStrn = res_mt?.["comp_saleTaxNo"];
          let clntCnic = res_mt?.["client_cnic"];
          let clntNtax = res_mt?.["client_ntax"];
          let clntStrn = res_mt?.["client_strn"];
          let fbr_inv_id = res_mt?.["fbr_inv_id"];
          let issueDate = res_mt?.["issueDate"];
          let dueDate = res_mt?.["dueDate"];
          let clientName = res_mt?.["Client_Name"];
          let Item_Desc_Lov = res_det[0]?.["Item_Desc_Lov"];
          let address = res_mt?.["supplierAdress"];
          let email = res_mt?.["email"];
          let phone = res_mt?.["phone"];
          let CURRENCY_DESC = res_mt?.["CURRENCY_DESC"];
          let company_no = res_mt?.["company_no"];
          let dynamicInvMessage =
            state?.headerPrefix === "Item Adjusment" ||
            state?.headerPrefix === "Production Note" ||
            state?.headerPrefix === "GOODS RECEIPT NOTE"
              ? ""
              : "Invoice";
          let specificMsg =
            state?.headerPrefix === "Item Adjusment" ||
            state?.headerPrefix === "Production Note" ||
            state?.headerPrefix === "GOODS RECEIPT NOTE"
              ? "Doc"
              : "";
          for (let index = 0; index < res_det.length; index++) {
            totalBags += res_det[index].item_qty;
            totalWeight += res_det[index].ad_weight;
            total_btAmount += res_det[index].item_bt_amount;
            totalsalesTaxPay += res_det[index].item_sale_tax_amount;
            total_atAmount += res_det[index].at_amount;
          }
          if (invBookId) {
            thisContex.getFooterDataWithId(
              res_mt?.["INV_BOOK_ID"],
              res_det.length
            );
          }
          thisContex.setState({
            loadingResponce: false,
            invoiceNo: invoiceNo,
            issueDate: moment(issueDate).format("DD-MM-YYYY"),
            dueDate: moment(dueDate).format("DD-MM-YYYY"),
            clientName: clientName,
            compNtn,
            compStrn,
            clntCnic,
            clntNtax,
            clntStrn,
            fbr_inv_id: fbr_inv_id ? fbr_inv_id : "N/A",
            res_det: res_det,
            Item_Desc_Lov,
            totalBags: totalBags,
            totalWeight: totalWeight,
            total_btAmount: total_btAmount,
            totalsalesTaxPay: totalsalesTaxPay,
            total_atAmount: total_atAmount,
            address,
            email,
            phone,
            company_no,
            CURRENCY_DESC,
            invBookId,
            dynamicInvMessage,
            specificMsg,
            state,
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }

  goBackToInvoice() {
    console.log(
      "ridirect............",
      this.props?.location?.state?.updateCheck
    );
    console.log("ridirect............", this.props?.location?.state);
    this.setState({
      goBack: true,
    });
  }

  render() {
    const {
      invoiceId,
      logInStatus,
      invoiceNo,
      issueDate,
      dueDate,
      companyName,
      companyAddress,
      clientName,
      compNtn,
      compStrn,
      clntCnic,
      clntNtax,
      clntStrn,
      fbr_inv_id,
      totalBags,
      totalWeight,
      total_btAmount,
      totalsalesTaxPay,
      total_atAmount,
      phone,
      email,
      address,
      goBack,
      dynamicInvMessage,
      headerPrefix,
      loadingResponce,
      specificMsg,
    } = this.state;
    if (!logInStatus) return <Redirect to="/login" />;
    else if (loadingResponce) {
      return <Responseloader />;
    } else if (goBack) {
      return (
        <Redirect
          // to="/CreativeInvoice"
          push
          to={{
            pathname: this.props?.location?.state?.url,
            state: {
              id: this.state.invoiceId,
              updateCheck: this.props?.location?.state?.updateCheck, //AHMAD
              // updateCheck: 2, //AHMAD
            },
          }}
        />
      );
    } else if (invoiceId !== -1) {
      return (
        <div className="pdfContent-Print" id="pdfContent-Print">
          <Row className="app-body-Invoice bg-white">
            <Col xs="12">
              <Row className="align-items-center border-bottom pb-2 mb-3">
                {/* Left: Logo */}
                <Col xs="2" className="text-center">
                  <img
                    src={
                      companyNameLocal === "Chakwal"
                        ? ChakwalLogo
                        : companyNameLocal === "AA_Cotton"
                        ? AaCottonLogo
                        : ""
                    }
                    alt="logo"
                    style={{
                      maxWidth: "100%",
                      height: "119px",
                      objectFit: "contain",
                    }}
                  />
                </Col>

                {/* Center: Company Details */}
                <Col xs="8" className="text-center">
                  <h3
                    className="mb-1"
                    style={{
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      // color: companyNameLocal === "Chakwal" ? "#DD840F" : "",
                    }}
                  >
                    Sales Tax Invoice ({this.state.invoiceTypeDesc})
                  </h3>
                  <h4
                    className="mb-1"
                    style={{
                      fontWeight: "bold",
                      // color: companyNameLocal === "Chakwal" ? "#DD840F" : "",
                    }}
                  >
                    {companyName}
                  </h4>
                  <p className="mb-1">{companyAddress}</p>
                  <h5>
                    {/* <small style={{ fontSize: "0.9rem" }}> */}
                    STRN: {compStrn}, NTN: {compNtn}
                    {/* </small> */}
                  </h5>
                </Col>

                {/* Right: Action Buttons */}
                <Col xs="2" className="text-end">
                  <button
                    className="btn btn-primary mb-1"
                    id="printPageButton"
                    onClick={() => window.print()}
                  >
                    Print to PDF
                  </button>
                  <br />
                  <button
                    className="btn btn-secondary"
                    id="printPageButton"
                    onClick={() => this.goBackToInvoice()}
                  >
                    Back
                  </button>
                </Col>
              </Row>

              <br></br>
              {/* <hr
                style={{
                  marginTop: "-0.5rem",
                  border: "1px solid Light gray",
                }}
              /> */}
              <Row className="px-4 display-flex flex">
                <Col xs="6" style={{ marginTop: "-1%", marginBottom: "3%" }}>
                  <fieldset
                    style={{
                      border: "2px solid #000",
                      borderRadius: "6px",
                      padding: "10px 15px",
                      margin: 0,
                      minHeight: "100px",
                      position: "relative",
                    }}
                  >
                    <legend
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        padding: "0 10px",
                        width: "auto",
                        marginBottom: 0,
                      }}
                    >
                      Sent To
                    </legend>

                    <h4>
                      <b>{clientName}</b>
                    </h4>

                    {/* Address */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "-5px",
                      }}
                    >
                      <h5 style={{ marginRight: "10px", minWidth: "100px" }}>
                        Address:
                      </h5>
                      <h6>{address}</h6>
                    </div>

                    {/* Phone */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "-5px",
                      }}
                    >
                      <h5 style={{ marginRight: "10px", minWidth: "100px" }}>
                        Phone:
                      </h5>
                      <h6>{phone}</h6>
                    </div>

                    {/* Email */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "-5px",
                      }}
                    >
                      <h5 style={{ marginRight: "10px", minWidth: "100px" }}>
                        E-Mail:
                      </h5>
                      <h6>{email}</h6>
                    </div>

                    {/* NTN */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "-5px",
                      }}
                    >
                      <h5 style={{ marginRight: "10px", minWidth: "100px" }}>
                        NTN:
                      </h5>
                      <h6>{clntNtax}</h6>
                    </div>

                    {/* STRN */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "-5px",
                      }}
                    >
                      <h5 style={{ marginRight: "10px", minWidth: "100px" }}>
                        STRN:
                      </h5>
                      <h6>{clntStrn}</h6>
                    </div>

                    {/* CNIC */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "-5px",
                      }}
                    >
                      <h5 style={{ marginRight: "10px", minWidth: "100px" }}>
                        CNIC:
                      </h5>
                      <h6>{clntCnic}</h6>
                    </div>
                  </fieldset>
                </Col>

                <Col
                  xs="6"
                  className="px-4"
                  style={{
                    marginLeft: "76%", // Adjust the horizontal position as needed
                    marginTop: "-14.5%", // Adjust the vertical position as needed
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start", // Align all items to the start of the column
                  }}
                >
                  {/* Invoice Message and Number */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      {specificMsg ? specificMsg : dynamicInvMessage} No:
                    </h4>
                    <span style={{ marginLeft: "0px" }}>
                      <h5>{invoiceNo}</h5>
                    </span>
                  </div>

                  {/* Issue Date */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      Issue Date:
                    </h4>
                    <span style={{ marginLeft: "4px" }}>
                      <h5>{issueDate}</h5>
                    </span>
                  </div>

                  {/* Due Date */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      Due Date:
                    </h4>
                    <span style={{ marginLeft: "7px" }}>
                      <h5>{dueDate}</h5>
                    </span>
                  </div>
                </Col>
              </Row>
              <hr
                style={{
                  border: "0.5px solid #706f6f",
                  marginTop: "-2%",
                }}
              />
              <Row xs="12" className="px-4">
                <Col xs="12">
                  {this.state.invoiceTypeDesc === "Yarn" ? (
                    <table style={{ width: "100%" }} className="my-table-yarn">
                      <colgroup>
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "7.5%" }} />
                        <col style={{ width: "7.5%" }} />
                        <col style={{ width: "7%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "9%" }} />
                        <col style={{ width: "7%" }} />
                        <col style={{ width: "7%" }} />
                        <col style={{ width: "12%" }} />
                      </colgroup>

                      <thead>
                        <tr>
                          <th rowSpan="2" className="border">
                            Description
                          </th>
                          <th colSpan="2" className="border text-center">
                            Quantity
                          </th>
                          <th rowSpan="2" className="border text-right">
                            HS Code
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Price
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Value Excl. STax
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Sales Tax (%)
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Sales Tax Payable
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Further Tax Payable (%)
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Further Payable
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Value Incl. STax
                          </th>
                        </tr>
                        <tr>
                          <th className="border text-right">Bags</th>
                          <th className="border text-right">Kgs (UOM)</th>
                        </tr>
                      </thead>

                      <tbody>
                        {this.state.res_det?.map((itm, index) => (
                          <tr key={index}>
                            <td>{itm.item_desc}</td>
                            <td className="text-right">
                              {itm.item_qty
                                ?.toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right">
                              {/* {itm.ad_weight != null
                                ? Math.round(itm.ad_weight)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : ""} */}
                              {itm.ad_weight
                                ?.toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right">
                              {itm.hs_code || null}
                            </td>
                            <td className="text-right">
                              {(itm.item_bt_amount / itm.ad_weight)
                                ?.toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right">
                              {itm.item_bt_amount
                                ?.toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              {/* {itm.item_bt_amount != null
                                ? Math.round(itm.item_bt_amount)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : ""} */}
                            </td>
                            <td className="text-right">
                              {itm.stax_rate
                                ?.toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              %{/* 18.00% */}
                            </td>
                            <td className="text-right">
                              {" "}
                              {itm.item_sale_tax_amount
                                ?.toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              {/* {itm.item_sale_tax_amount != null
                                ? Math.round(itm.item_sale_tax_amount)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : ""} */}
                            </td>
                            <td className="text-right">0.00%</td>
                            <td className="text-right">0.00</td>
                            <td className="text-right">
                              {itm.at_amount
                                ?.toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              {/* {itm.at_amount != null
                                ? Math.round(itm.at_amount)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : ""} */}
                            </td>
                          </tr>
                        ))}
                      </tbody>

                      <tfoot>
                        <tr
                          style={{
                            fontWeight: "bold",
                            borderTop: "2px solid #000",
                          }}
                        >
                          <td className="text-center">Total</td>
                          <td className="text-right">
                            {totalBags
                              ?.toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            {/* 1000 */}
                          </td>
                          <td className="text-right">
                            {totalWeight
                              ?.toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            {/* 1000 */}
                            {/* {totalWeight != null
                              ? Math.round(totalWeight)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              : ""} */}
                          </td>
                          <td className="text-right">
                            {/* Optional: total of rates if needed */}
                          </td>
                          <td className="text-right">
                            {/* Optional: total of rates if needed */}
                          </td>
                          <td className="text-right">
                            {total_btAmount
                              ?.toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            {/* 1000 */}
                            {/* {total_btAmount != null
                              ? Math.round(total_btAmount)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              : ""} */}
                          </td>
                          <td className="text-right">
                            {/* {total_bags
                            ?.toFixed(2)
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} */}
                            {/* 1000 */}
                          </td>
                          <td className="text-right">
                            {totalsalesTaxPay
                              ?.toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            {/* 1000 */}
                            {/* {totalsalesTaxPay != null
                              ? Math.round(totalsalesTaxPay)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              : ""} */}
                          </td>
                          <td className="text-right">
                            {/* {total_bags
                            ?.toFixed(2)
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} */}
                            0.00
                          </td>
                          <td className="text-right">
                            {/* {total_bags
                            ?.toFixed(2)
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} */}
                            0.00
                          </td>
                          <td className="text-right">
                            {total_atAmount
                              ?.toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            {/* 1000 */}
                            {/* {total_atAmount != null
                              ? Math.round(total_atAmount)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              : ""} */}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  ) : (
                    <table style={{ width: "100%" }} className="my-table">
                      <colgroup>
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "11%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "10%" }} />
                      </colgroup>

                      <thead>
                        <tr>
                          <th rowSpan="2" className="border">
                            Description
                          </th>
                          <th rowSpan="1" className="border text-center">
                            Quantity
                          </th>
                          <th rowSpan="2" className="border text-right">
                            HS Code
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Price
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Value Excl. STax
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Sales Tax (%)
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Sales Tax Payable
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Furth Tax (%)
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Furth Tax Payable
                          </th>
                          <th rowSpan="2" className="border text-right">
                            Value Incl. STax
                          </th>
                        </tr>
                        <tr>
                          <th className="border text-right">
                            {this.state.invoiceTypeDesc === "Other"
                              ? "No":this.state.invoiceTypeDesc === "Fabric" ? "Mtrs"
                              : "Kgs"}{" "}
                            (UOM)
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {this.state.res_det?.map((itm, index) => (
                          <tr key={index}>
                            <td>{itm.item_desc}</td>
                            <td className="text-right">
                              {itm.item_qty
                                ?.toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right">{itm.hs_code || ""}</td>
                            <td className="text-right">
                              {itm.item_rate
                                ?.toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              {/* {itm.item_rate != null
                                ? Math.round(itm.item_rate)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : ""} */}
                            </td>
                            <td className="text-right">
                              {itm.item_bt_amount
                                ?.toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              {/* {itm.item_bt_amount != null
                                ? Math.round(itm.item_bt_amount)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : ""} */}
                            </td>
                            <td className="text-right">
                              {itm.stax_rate?.toFixed(2)}%
                            </td>
                            <td className="text-right">
                              {itm.item_sale_tax_amount
                                ?.toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right">0.00%</td>
                            <td className="text-right">0.00</td>
                            <td className="text-right">
                              {itm.at_amount
                                ?.toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              {/* {itm.at_amount != null
                                ? Math.round(itm.at_amount)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : ""} */}
                            </td>
                          </tr>
                        ))}
                      </tbody>

                      <tfoot>
                        <tr
                          style={{
                            fontWeight: "bold",
                            borderTop: "2px solid #000",
                          }}
                        >
                          <td className="text-center">Total</td>
                          <td className="text-right">
                            {totalBags
                              ?.toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            {/* {totalWeight != null
                              ? Math.round(totalWeight)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              : ""} */}
                          </td>
                          <td className="text-right"></td>
                          <td className="text-right"></td>
                          <td className="text-right">
                            {total_btAmount
                              ?.toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            {/* {total_btAmount != null
                              ? Math.round(total_btAmount)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              : ""} */}
                          </td>
                          <td className="text-right"></td>
                          <td className="text-right">
                            {totalsalesTaxPay
                              ?.toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            {/* {totalsalesTaxPay != null
                              ? Math.round(totalsalesTaxPay)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              : ""} */}
                          </td>
                          <td className="text-right"></td>
                          <td className="text-right">0.00</td>
                          <td className="text-right">
                            {total_atAmount
                              ?.toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            {/* {total_atAmount != null
                              ? Math.round(total_atAmount)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              : ""} */}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  )}
                </Col>
              </Row>
            </Col>

            <Container
              className={`${
                this.state.setNextPrintPageFooter
                  ? "footerNewPage"
                  : "footerPrint"
              }`}
              // className="footer"
              style={{ backgroundColor: "white" }}
            >
              <Row
                className="mt-5 footerRows"
                style={{
                  textAlign: "center",
                }}
              >
                {this.state.setFooterData.map((row) => (
                  <Col
                    lg="4"
                    md="4"
                    sm="4"
                    className="px-4"
                    style={{
                      marginBottom: "3rem",
                      marginTop: row.enteredBy != 1 ? "1.3rem" : "0",
                      textAlign: "center",
                    }}
                  >
                    <h5>
                      {" "}
                      {row.enteredBy
                        ? row.enteredBy /*printData[0]?.name*/
                        : "  "}
                    </h5>
                    <hr
                      style={{
                        border: "1px solid ",
                        borderColor: "E4E5E6",
                        margin: "revert",
                      }}
                    />
                    <h4 key={row.id}>{row.desc}</h4>
                  </Col>
                ))}
              </Row>
            </Container>
            {/* {fbr_inv_id != "N/A" ? ( */}
            <div className="fbr-logo-qr-code">
              <div
                style={{
                  height: "auto",
                  maxWidth: 64,
                  width: "100%",
                }}
              >
                <img
                  src={FBRlogo}
                  alt="FBR Logo"
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                />
              </div>
              <div
                style={{
                  height: "auto",
                  marginLeft: "1rem",
                  maxWidth: 64,
                  width: "100%",
                }}
              >
                <QRCode
                  size={256}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  value={fbr_inv_id}
                  viewBox={`0 0 256 256`}
                />
                FBR ID: {fbr_inv_id}
              </div>
            </div>
            {/* // ) : (
            //   ""
            // )} */}
          </Row>
        </div>
      );
    } else {
      return (
        <div>
          <Row className="app-body-Invoice">
            <Col>
              <div
                className="col-md-12"
                style={{ width: "1100px", margin: "0 auto" }}
              >
                <div className="col-md-9">
                  <div className="row">
                    <div className="col-md-12">
                      <h2 style={{ fontWeight: "bold" }}>
                        <Redirect to="/OverviewInvoice" />
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      );
    }
  }
}

export default PrintView;
